import { Component } from "@theme/component";

/**
 * Valor e Prazo por UF
 */
const SHIPPING_PROFILE_BY_STATE = {
  DF: { fee: "R$ 12", eta: [3, 8] },
  ES: { fee: "R$ 12", eta: [3, 8] },
  GO: { fee: "R$ 12", eta: [3, 8] },
  MG: { fee: "R$ 12", eta: [3, 8] },
  MS: { fee: "R$ 12", eta: [3, 8] },
  MT: { fee: "R$ 12", eta: [3, 8] },
  PR: { fee: "R$ 12", eta: [3, 8] },
  RJ: { fee: "R$ 12", eta: [3, 8] },
  RS: { fee: "R$ 12", eta: [3, 8] },
  SC: { fee: "R$ 12", eta: [3, 8] },
  SP: { fee: "R$ 12", eta: [3, 8] },
  AL: { fee: "R$ 12", eta: [4, 12] },
  BA: { fee: "R$ 12", eta: [4, 12] },
  CE: { fee: "R$ 12", eta: [4, 12] },
  MA: { fee: "R$ 12", eta: [4, 12] },
  PB: { fee: "R$ 12", eta: [4, 12] },
  PE: { fee: "R$ 12", eta: [4, 12] },
  PI: { fee: "R$ 12", eta: [4, 12] },
  RN: { fee: "R$ 12", eta: [4, 12] },
  SE: { fee: "R$ 12", eta: [4, 12] },
  AC: { fee: "R$ 12", eta: [5, 15] },
  AM: { fee: "R$ 12", eta: [5, 15] },
  AP: { fee: "R$ 12", eta: [5, 15] },
  PA: { fee: "R$ 12", eta: [5, 15] },
  RO: { fee: "R$ 12", eta: [5, 15] },
  RR: { fee: "R$ 12", eta: [5, 15] },
  TO: { fee: "R$ 12", eta: [5, 15] },
};

const DEFAULT_SHIPPING_PROFILE = { fee: "R$ 12", eta: [3, 12] };

const DATE_FORMATTER_MONTH = new Intl.DateTimeFormat("pt-BR", {
  month: "long",
});

// @ts-ignore
function onlyDigits(value) {
  return String(value || "").replace(/\D+/g, "");
}

// @ts-ignore
function asCepMask(value) {
  const raw = onlyDigits(value).slice(0, 8);
  return raw.length > 5 ? `${raw.slice(0, 5)}-${raw.slice(5)}` : raw;
}

// @ts-ignore
function cepLooksValid(value) {
  return onlyDigits(value).length === 8;
}

// @ts-ignore
function getShippingProfile(uf) {
  return (
    // @ts-ignore
    SHIPPING_PROFILE_BY_STATE[String(uf || "").toUpperCase()] ||
    DEFAULT_SHIPPING_PROFILE
  );
}

// @ts-ignore
function isWeekday(date) {
  const day = date.getDay();
  return day >= 1 && day <= 5;
}

// @ts-ignore
function moveForwardByBusinessDays(baseDate, distance) {
  const cursor = new Date(
    baseDate.getFullYear(),
    baseDate.getMonth(),
    baseDate.getDate(),
    12,
    0,
    0,
    0,
  );

  let remaining = Math.max(0, Number(distance) || 0);

  while (remaining > 0) {
    cursor.setDate(cursor.getDate() + 1);
    if (isWeekday(cursor)) remaining -= 1;
  }

  return cursor;
}

// @ts-ignore
function buildDeliveryWindow([minDays, maxDays], now = new Date()) {
  const start = moveForwardByBusinessDays(now, minDays);
  const end = moveForwardByBusinessDays(now, maxDays);

  const sameMonth =
    start.getMonth() === end.getMonth() &&
    start.getFullYear() === end.getFullYear();

  if (sameMonth) {
    const monthLabel = DATE_FORMATTER_MONTH.format(end);
    return `entre ${start.getDate()} e ${end.getDate()} de ${monthLabel}`;
  }

  const startLabel = `${String(start.getDate()).padStart(2, "0")}/${String(
    start.getMonth() + 1,
  ).padStart(2, "0")}`;

  const endMonthLabel = DATE_FORMATTER_MONTH.format(end);
  return `entre ${startLabel} e ${end.getDate()} de ${endMonthLabel}`;
}

// @ts-ignore
async function updateCartAttributes(attributes) {
  try {
    const response = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "same-origin",
      body: JSON.stringify({ attributes }),
    });

    if (!response.ok) {
      throw new Error("cart_attribute_update_failed");
    }

    return await response.json();
  } catch (error) {
    // Não bloqueia o UX do cálculo de frete.
    // @ts-ignore
    console.warn(
      "[calculo-frete] Falha ao salvar atributos do carrinho",
      error,
    );
    return null;
  }
}

// @ts-ignore
async function lookupZipCode(cep) {
  const cleaned = onlyDigits(cep);
  const response = await fetch(`https://viacep.com.br/ws/${cleaned}/json/`, {
    headers: {
      Accept: "application/json",
    },
  });

  if (!response.ok) {
    throw new Error("zip_lookup_failed");
  }

  const payload = await response.json();

  if (payload?.erro) {
    return null;
  }

  return {
    city: String(payload.localidade || "").trim(),
    state: String(payload.uf || "")
      .trim()
      .toUpperCase(),
  };
}

function createInitialViewState() {
  return {
    expanded: true,
    loading: false,
    title: "",
    subtitle: "",
    hasResult: false,
  };
}

class CalculoFrete extends Component {
  #nodes = {
    card: null,
    trigger: null,
    close: null,
    input: null,
    button: null,
    resultWrap: null,
    resultTitle: null,
    resultSub: null,
  };

  #view = createInitialViewState();

  connectedCallback() {
    super.connectedCallback();

    this.#cacheNodes();

    if (!this.#nodes.input || !this.#nodes.button) return;

    this.#bindEvents();
    this.#paint();
  }

  #cacheNodes() {
    // @ts-ignore
    this.#nodes.card = this.querySelector(".calculo-frete-card");
    // @ts-ignore
    this.#nodes.trigger = this.querySelector(".calculo-frete__trigger");
    // @ts-ignore
    this.#nodes.close = this.querySelector(".calculo-frete__close");
    // @ts-ignore
    this.#nodes.input = this.querySelector(".calculo-frete__input");
    // @ts-ignore
    this.#nodes.button = this.querySelector(".calculo-frete__button");
    // @ts-ignore
    this.#nodes.resultWrap = this.querySelector(".calculo-frete__result-inner");
    // @ts-ignore
    this.#nodes.resultTitle = this.querySelector(
      ".calculo-frete__result-title",
    );
    // @ts-ignore
    this.#nodes.resultSub = this.querySelector(
      ".calculo-frete__result-subtext",
    );
  }

  #bindEvents() {
    // @ts-ignore
    this.#nodes.trigger?.addEventListener("click", () => {
      this.#view.expanded = !this.#view.expanded;
      this.#paint();

      if (this.#view.expanded) {
        // @ts-ignore
        window.setTimeout(() => this.#nodes.input?.focus(), 80);
      }
    });

    // @ts-ignore
    this.#nodes.close?.addEventListener("click", () => {
      this.#view.expanded = false;
      this.#paint();
    });

    // @ts-ignore
    this.#nodes.input?.addEventListener("input", () => {
      if (!this.#nodes.input) return;
      // @ts-ignore
      this.#nodes.input.value = asCepMask(this.#nodes.input.value);
    });

    // @ts-ignore
    this.#nodes.input?.addEventListener("keydown", (event) => {
      if (event.key !== "Enter") return;
      event.preventDefault();
      this.#submit();
    });

    // @ts-ignore
    this.#nodes.button?.addEventListener("click", () => {
      this.#submit();
    });
  }

  #paint() {
    const { card, button, resultWrap, resultTitle, resultSub } = this.#nodes;
    const { expanded, loading, title, subtitle, hasResult } = this.#view;

    this.setAttribute("data-expanded", String(expanded));

    if (card) {
      // @ts-ignore
      card.setAttribute("data-has-result", String(hasResult));
    }

    if (resultWrap) {
      // @ts-ignore
      resultWrap.style.display = hasResult ? "grid" : "none";
    }

    if (resultTitle) {
      // @ts-ignore
      resultTitle.textContent = title;
    }

    if (resultSub) {
      // @ts-ignore
      resultSub.textContent = subtitle;
    }

    if (button) {
      // @ts-ignore
      button.disabled = loading;
      // @ts-ignore
      button.ariaBusy = String(loading);
      // @ts-ignore
      button.textContent = loading ? "Calculando..." : "Calcular";
    }
  }

  // @ts-ignore
  #showFeedback(title, subtitle = "") {
    this.#view.title = title;
    this.#view.subtitle = subtitle;
    this.#view.hasResult = true;
    this.#paint();
  }

  async #submit() {
    if (!this.#nodes.input) return;

    // @ts-ignore
    const userCep = this.#nodes.input.value;

    this.#view.expanded = true;
    this.#paint();

    if (!cepLooksValid(userCep)) {
      this.#showFeedback("CEP inválido. Insira no formato 00000-000.", "");
      return;
    }

    this.#view.loading = true;
    this.#view.hasResult = true;
    this.#view.title = "Consultando CEP...";
    this.#view.subtitle = "";
    this.#paint();

    try {
      const place = await lookupZipCode(userCep);

      if (!place) {
        this.#showFeedback("CEP não encontrado. Tente novamente.", "");
        return;
      }

      const shipping = getShippingProfile(place.state);
      const deliveryLabel = buildDeliveryWindow(shipping.eta);

      // Persistir no carrinho a data/hora da consulta e o prazo estimado.
      // (Atributos do carrinho do Shopify aparecem no pedido como note attributes.)
      updateCartAttributes({
        __frete_consultado_em: new Date().toISOString(),
        __frete_prazo_estimado: deliveryLabel,
      });

      this.#showFeedback(
        `Frete fixo por ${shipping.fee} para ${place.city} - ${place.state}`,
        `Entrega estimada ${deliveryLabel}.`,
      );
    } catch {
      this.#showFeedback(
        "Erro ao buscar informações do CEP. Tente novamente.",
        "",
      );
    } finally {
      this.#view.loading = false;
      this.#paint();
    }
  }
}

if (!customElements.get("calculo-frete")) {
  customElements.define("calculo-frete", CalculoFrete);
}
